import { AgsBorderHighlightBehaviour } from "ags/behaviours/ags-border-highlight";
import { ThemeLoopWinsComponent } from "components/theme-loop-wins-component";
import { Contract } from "appworks/utils/contracts/contract";
import { Timer } from "appworks/utils/timer";
import { Sequence } from "appworks/utils/contracts/sequence";


export class ThemeBorderHighlightBehaviour extends AgsBorderHighlightBehaviour {
    public cycle(): Contract<void> {
        return new Contract<void>((resolve) => {
            this.animate("_over", [this.defaultAnimation]).execute();

            // this.animation.parent.addChildAt(this.animation, 0); // Moves winbox to back

            Timer.setTimeout(() => {
                if (this.animation) {
                    this.animation.visible = false;
                }
                resolve(null);
            }, ThemeLoopWinsComponent.minCelebrationDuration);
        });
    }

    public highlight(): Contract<void> {

        return new Contract<void>((resolve) => {
            this.animate( "_over", [this.defaultAnimation]).execute();

            // this.animation.parent.addChildAt(this.animation, 0); // Moves winbox to back

            Timer.setTimeout(() => {
                if (this.animation) {
                    this.animation.visible = false;
                }
                resolve(null);
            }, ThemeLoopWinsComponent.minCelebrationDuration);
        });
    }

    public win(): Contract<void> {
        return new Contract<void>((resolve) => {
            this.animate( "_over", [this.defaultAnimation]).execute();

            // this.animation.parent.addChildAt(this.animation, 0); // Moves winbox to back

            Timer.setTimeout(() => {
                if (this.animation) {
                    this.animation.visible = false;
                }
                resolve(null);
            }, ThemeLoopWinsComponent.minCelebrationDuration);
        });
    }
}
